import { useEffect } from 'react';
import useCartPersist from './useCartPersist';
import useWishlistPersist from './useWishlistPersist';

export const useGlobalUserData = () => {
  const { loadCartFromServer } = useCartPersist();
  const { loadWishlistFromServer } = useWishlistPersist();

  useEffect(() => {
    // 检查用户是否已登录
    const userInfo = JSON.parse(localStorage.getItem('user_info')) || {};
    if (userInfo.id) {
      // 如果已登录，加载购物车和心愿单数据
      loadCartFromServer();
      loadWishlistFromServer();
    }
  }, []); // 只在组件挂载时执行一次

  return null;
};

export default useGlobalUserData; 
